import {
  Box,
  Typography,
  IconButton,
  Button,
  Container,
  Stack,
  Divider,
} from "@mui/material";
import { Facebook, LinkedIn } from "@mui/icons-material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
// import companyLogo from "../assets/images/company-logo.webp";
import phone from "../assets/footer/phone.png";
import mail from "../assets/footer/mail.png";
import location from "../assets/footer/location.png";
import footermain from "../assets/footer/footer-main.png";
import { paths } from "../routes/path";
import { Link } from "react-router-dom";
import companyLogo from "../assets/images/company-logo-desk.svg";
import emologo from "../assets/images/emo.svg";
import { Icon } from "@iconify/react";

export default function Footer() {
  const footerLinks = [
    {
      label: "Terms and Conditions",
      path: paths.dashboard.termsAndConditions,
    },
    {
      label: "Privacy Policy",
      path: paths.dashboard.privacyPolicy,
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#F9F9F9",
        mb: { xs: 6, md: 0 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction="row"
          alignItems="start"
          sx={{
            maxWidth: "100%",
            flexDirection: { xs: "column", md: "row" },
            spacing: { xs: 0, md: 2 },
            gap: "20px",
          }}
        >
          {/* Mobile: Company Information Section */}
          <Box
            sx={{
              width: "100%",
              py: 3,
              order: 1,
              display: { xs: "block", md: "none" },
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  mb: 2,
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img
                  src={companyLogo}
                  alt="Company Logo"
                  width={"200px"}
                  height={"50px"}
                />
              </Box>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 3,
                  lineHeight: 1.6,
                  fontFamily: "Inter, sans-serif",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                PSN Finance delivers transparent, reliable loans to
                <br />
                empower your growth - from personal and business
                <br />
                to housing and vehicle finance.
              </Typography>
            </Box>

            {/* Mobile: Combined Connect with us and Quick Links */}
            <Box
              sx={{
                display: { xs: "grid", md: "none" },
                gridTemplateColumns: "repeat(2, 1fr)",
                width: "100%",
                gap: 2,
                mb: 3,
              }}
            >
              {/* Connect with us section */}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#002B7A",
                    mb: 2,
                    fontSize: "18px",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                    position: "relative",
                    textAlign: "center",
                    display: "inline-block",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "-6px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "60px",
                      height: "2px",
                      backgroundColor: "#00cc87",
                    },
                  }}
                >
                  Connect with us
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 1.5,
                    mt: 2,
                  }}
                >
                  <IconButton
                    href="#"
                    sx={{
                      backgroundColor: "#fff",
                      color: "#1877F2", // Facebook blue color
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      border: "1px solid #E0E0E0",
                      "&:hover": {
                        backgroundColor: "#1877F2",
                        color: "white",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Icon icon="mdi:facebook" width={24} height={24} />
                  </IconButton>

                  <IconButton
                    href="https://www.linkedin.com/company/psn-group-of-companies/"
                    target="_blank"
                    sx={{
                      backgroundColor: "#fff",
                      color: "#0A66C2", // LinkedIn blue color
                      width: 40,
                      borderRadius: "10px",
                      height: 40,
                      border: "1px solid #E0E0E0",
                      "&:hover": {
                        backgroundColor: "#0A66C2",
                        color: "white",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Icon icon="mdi:linkedin" width={24} height={24} />
                  </IconButton>
                </Box>
              </Box>

              {/* Quick Links Section - Mobile */}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#002B7A",
                    mb: 2,
                    fontSize: "18px",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                    position: "relative",
                    textAlign: "center",
                    display: "inline-block",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "-6px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "60px",
                      height: "2px",
                      backgroundColor: "#00cc87",
                    },
                  }}
                >
                  Quick links
                </Typography>

                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1.5,
                  }}
                >
                  {[
                    { text: "Our Products", path: "/our-product-1" },
                    { text: "Contact Us", path: "/contact-us" },
                  ].map((item) => (
                    <Box key={item.text}>
                      <Box
                        component={Link}
                        to={item.path}
                        style={{ textDecoration: "none" }}
                        underline="none"
                        sx={{
                          color: "text.secondary",
                          fontSize: "14px",
                          fontFamily: "Inter, sans-serif",
                          "&:hover": {
                            color: "#3498db",
                          },
                          textAlign: "center",
                        }}
                      >
                        {item.text}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>

            {/* Mobile: Terms and Conditions / Privacy Policy Links */}
            <Box
              sx={{
                width: "100%",
                mt: 0,
                mb: 1,
                display: { xs: "flex", md: "none" },
                justifyContent: "center",
              }}
            >
              <Stack
                direction="row"
                spacing={3}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {footerLinks?.map((item, index) => (
                  <Box
                    component={Link}
                    style={{ textDecoration: "none" }}
                    key={index}
                    to={item?.path}
                    sx={{
                      color: "text.secondary",
                      fontSize: "13px",
                      lineHeight: 1.4,
                      textAlign: "center",
                      fontFamily: "Inter, sans-serif",
                      "&:hover": {
                        cursor: "pointer",
                        color: "#3498db",
                        textDecoration: "none",
                      },
                    }}
                  >
                    {item?.label}
                  </Box>
                ))}
              </Stack>
            </Box>
          </Box>

          {/* Desktop: Company Information Section */}
          <Box
            sx={{
              width: "35%",
              py: 6,
              display: { xs: "none", md: "block" },
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  mb: 2,
                  width: "100%",
                }}
              >
                <img
                  src={companyLogo}
                  alt="Company Logo"
                  width={"200px"}
                  height={"80px"}
                />
              </Box>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                sx={{
                  mb: 3,
                  lineHeight: 1.6,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                PSN Finance delivers transparent, reliable loans to empower your
                growth - from personal and business to housing and vehicle
                finance.
              </Typography>
            </Box>

            <Typography
              variant="h6"
              sx={{
                color: "##002B7A",
                mb: 2,
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "Inter, sans-serif",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-8px",
                  left: 0,
                  width: "90px",
                  height: "2px",
                  backgroundColor: "#00cc87",
                },
              }}
            >
              Connect with us
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                mt: 3,
              }}
            >
              <IconButton
                href="#"
                sx={{
                  backgroundColor: "#fff",
                  color: "#1877F2", // Facebook blue color
                  width: 40,
                  height: 40,
                  p: 0,
                  borderRadius: "10px",
                  // border: "1px solid #E0E0E0",
                  "&:hover": {
                    backgroundColor: "#1877F2",
                    color: "white",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Icon
                  icon="ant-design:facebook-outlined"
                  width={24}
                  height={24}
                />
              </IconButton>

              <IconButton
                href="https://www.linkedin.com/company/psn-group-of-companies/"
                target="_blank"
                sx={{
                  backgroundColor: "#fff",
                  color: "#0A66C2", // LinkedIn blue color
                  width: 40,
                  p: 0,
                  borderRadius: "10px",
                  height: 40,
                  // border: "1px solid #E0E0E0",
                  "&:hover": {
                    backgroundColor: "#0A66C2",
                    color: "white",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Icon icon="mingcute:linkedin-line" width={24} height={24} />
              </IconButton>
            </Box>
          </Box>

          {/* Mobile: Information Section - Centered */}
          <Box
            sx={{
              display: { xs: "block", md: "none" },
              width: "100%",
              py: 3,
              pt: 0,
              order: 2,
            }}
          >
            {/* Contact Information Section - Mobile */}
            <Box
              sx={{
                width: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#002B7A",
                  mb: 2,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Inter, sans-serif",
                  position: "relative",
                  textAlign: "center",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-4px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "60px",
                    height: "2px",
                    backgroundColor: "#00cc87",
                  },
                }}
              >
                Information
              </Typography>

              <Box
                sx={{
                  mt: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <a
                  href="tel:+916364903820"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                      gap: 2,
                      justifyContent: "center",
                    }}
                  >
                    <img src={phone} alt="Phone" style={{ width: "18px" }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: "center" }}
                    >
                      +91 63649 03820
                    </Typography>
                  </Box>
                </a>
                <a
                  href="mailto:support@psnfinance.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                      gap: 2,
                      justifyContent: "center",
                    }}
                  >
                    <img src={mail} alt="Phone" style={{ width: "18px" }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: "center" }}
                    >
                      support@psnfinance.com
                    </Typography>
                  </Box>
                </a>
                <a
                  href="mailto:support@psnfinance.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                      gap: 2,
                      justifyContent: "center",
                      flexDirection: "row",
                    }}
                  >
                    <img
                      src={location}
                      alt="Location"
                      style={{ width: "16px" }}
                    />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ maxWidth: "250px", textAlign: "center" }}
                    >
                      No.380, Ittina Center, Ground Floor, 3rd Block 16th Main,
                      Koramangala Bengaluru- 560034
                      <br /> CIN: U67190KA2010PTC053178
                    </Typography>
                  </Box>
                </a>
              </Box>
            </Box>
          </Box>

          {/* Desktop: Contact Information Section */}
          <Box
            sx={{
              width: "20%",
              py: 6,
              display: { xs: "none", md: "block" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#002B7A",
                mb: 2,
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "Inter, sans-serif",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-4px",
                  left: 0,
                  width: "60px",
                  height: "2px",
                  backgroundColor: "#00cc87",
                },
              }}
            >
              Information
            </Typography>

            <Box sx={{ mt: 3 }}>
              <a
                href="tel:6364903820"
                style={{ textDecoration: "none", cursor: "pointer" }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}
                >
                  <img src={phone} alt="Phone" />
                  <Typography variant="subtitle1" color="text.secondary">
                    +91 6364903820
                  </Typography>
                </Box>
              </a>
              <a
                href="mailto:support@psnfinance.com"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", cursor: "pointer" }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}
                >
                  <img src={mail} alt="Phone" />
                  <Typography variant="subtitle1" color="text.secondary">
                    support@psnfinance.com
                  </Typography>
                </Box>
              </a>
              <a
                href="mailto:support@psnfinance.com"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", cursor: "pointer" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    mb: 2,
                    gap: 2,
                  }}
                >
                  <img src={location} alt="Location" />
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{ maxWidth: "200px" }}
                  >
                    No.380, Ittina Center, Ground Floor, 3rd Block 16th Main,
                    Koramangala Bengaluru- 560034
                    <br /> CIN:U67190KA2010PTC053178
                  </Typography>
                </Box>
              </a>
            </Box>
          </Box>

          {/* Desktop: Quick Links Section */}
          <Box
            sx={{
              width: "20%",
              py: 6,
              display: { xs: "none", md: "block" },
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#002B7A",
                mb: 2,
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "Inter, sans-serif",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "-4px",
                  left: 0,
                  width: "60px",
                  height: "2px",
                  backgroundColor: "#00cc87",
                },
              }}
            >
              Quick links
            </Typography>

            <Box sx={{ mt: 3 }}>
              {[
                { text: "Our Products", path: "/our-product-1" },
                {
                  text: "Contact Us",
                  path: "/contact-us",
                },
              ].map((item) => (
                <Box key={item.text} sx={{ mb: 1.5 }}>
                  <Box
                    component={Link}
                    to={item.path}
                    style={{ textDecoration: "none" }}
                    underline="none"
                    sx={{
                      color: "text.secondary",
                      "&:hover": {
                        color: "#3498db",
                      },
                    }}
                  >
                    {item.text}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Customer Grievance Section */}
          <Box
            sx={{
              backgroundColor: "#FFF0F0",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: "100%", md: "25%" },
              px: { xs: 2, md: 3 },
              py: { xs: 3, md: 4 },
              order: { xs: 3, md: 4 },
              height: { xs: "auto", md: "400px" },
            }}
          >
            <img src={footermain} alt="PSN Logo" />
            <Typography
              variant="h5"
              color="#002B7A"
              sx={{
                lineHeight: 1.1,
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                textAlign: "center",
                mt: 2,
                fontSize: { xs: "20px", md: "23px" },
              }}
            >
              Customer Grievance
              <br />
              Redressal
            </Typography>

            <Button
              component={Link}
              size="small"
              color="text.secondary"
              sx={{
                fontSize: "14px",
                lineHeight: 1.4,
                textAlign: "center",
                fontFamily: "Inter, sans-serif",
                "&:hover": {
                  color: "#002B7A",
                },
              }}
              to={paths.dashboard.customerGrievance}
              underline="none"
            >
              Click here
            </Button>

            <Button
              variant="contained"
              component={Link}
              to={paths.dashboard.customerGrievance}
              id="customer-grievance-apply"
              sx={{
                backgroundColor: "#00cc87",
                color: "white",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                px: 3,
                py: 0.5,
                mt: 1,
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#0265fe",
                },
                minWidth: { xs: "120px", md: "auto" },
              }}
            >
              Apply Now
            </Button>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.4,
                mt: 2,
                textAlign: "center",
                fontFamily: "Inter, sans-serif",
                fontSize: { xs: "12px", md: "14px" },
              }}
            >
              Intensive Nationwide
              <br />
              Awareness Program by RBI
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Divider />
      <Box component="footer">
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "center", md: "stretch" },
            gap: { xs: 2, md: 0 },
            py: { xs: 2, md: 1 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.4,
                textAlign: "center",
                fontFamily: "Inter, sans-serif",
                fontSize: { xs: "12px", md: "14px" },
              }}
            >
              Copyright © 2025 PSN. All rights reserved. Designed & Developed by
            </Typography>
            <a href="https://emovur.com/" target="_blank" rel="noreferrer">
              <img
                src={emologo}
                alt="PSN Logo"
                width={"100px"}
                height={"22px"}
                style={{ marginTop: "4px", marginLeft: "6px" }}
              />
            </a>
          </Box>

          {/* Desktop Footer Links - Hidden on mobile since we moved them above */}
          <Stack
            direction="row"
            spacing={3}
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 3,
            }}
          >
            {footerLinks?.map((item, index) => (
              <Box
                component={Link}
                style={{ textDecoration: "none" }}
                key={index}
                variant="body2"
                to={item?.path}
                sx={{
                  color: "text.secondary",
                  fontSize: "14px",
                  lineHeight: 1.4,
                  textAlign: "center",
                  fontFamily: "Inter, sans-serif",
                  "&:hover": {
                    cursor: "pointer",
                    color: "#3498db",
                    textDecoration: "none",
                  },
                }}
              >
                {item?.label}
              </Box>
            ))}
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
